<script>
import { euroCouponsIssueMethods } from '@state/helpers'

export default {
  name: 'EuroCouponsIssueDetail',
  components: {},
  props: {
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      toDetail: {}
    }
  },
  computed: {},

  mounted: function () {
    let context = this
    if (context.instanceJson.url) {
      context.toDetail = {
        ...context.instanceJson,
      }
      context.getObject()
    } else {
      context.oncancel()
    }
  },

  methods: {
    ...euroCouponsIssueMethods,

    getObject() {
      let context = this
      const promise = context.fetchEuroCouponsIssueDetail(context.toDetail.url)
      return promise
        .then((data) => {
          context.toDetail = { ...data }
          context.loading = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.loading = false
          context.oncancel()
        })
    },
  },
}
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="`${ $t('detail_of') } ${ $t('issue') }`"
    ok-only
    hide-footer
    @hidden="oncancel"
  >
    <b-container class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col  class="mx-auto" md="12">
          <b-card-group deck>
            <b-card>
              <b-alert show variant="primary" class="shadow-sm font-weight-bold">{{toDetail.reason.description}}</b-alert>
              <!-- <pre>
                {{toDetail}}
              </pre> -->

            <b-list-group class="mb-3 border border-primary shadow">
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <b class="text-primary"><i class="fas fa-file-invoice-dollar"></i> {{ $t('invoice') }}</b>
                <b-badge variant="primary"  style="font-size: 13px">{{ toDetail.invoice }}</b-badge>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center ">
                <b class="text-primary"><i class="fas fa-user-tag"></i> {{ $t('thirdparty') }} </b>
                <b-badge variant="light" style="font-size: 13px">{{ toDetail.thirdparty }}</b-badge>
              </b-list-group-item>
              
              <b-list-group-item  class="d-flex justify-content-between align-items-center">
                <b class="text-primary"><i class="fas fa-map-marker-alt"></i> {{ $t('operation_center') }}</b>
                <b-badge variant="light"  style="font-size: 13px">{{ toDetail.CO }}</b-badge>

              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <b class="text-primary"><i class="fas fa-cash-register"></i> {{ $t('cash_register') }}</b>
                <b-badge variant="light"  style="font-size: 13px">{{ toDetail.cash_register }}</b-badge>
              </b-list-group-item>

              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <b class="text-primary"><i class="fas fa-id-card-alt"></i> {{ $t('cash_register_document') }}</b>
                <b-badge variant="light" style="font-size: 13px">{{ toDetail.cash_register_document }}</b-badge>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <b class="text-primary"><i class="fas fa-calendar-day"></i> {{ $t('date') }}</b>
                <b-badge variant="light"  style="font-size: 13px">{{ toDetail.date }}</b-badge>
              </b-list-group-item>
              <b-list-group-item
              v-if="toDetail.reason.type === 1 || toDetail.reason.type === 5 || toDetail.beneficiary" 
              class="d-flex justify-content-between align-items-center">
                <b class="text-primary"><i class="fas fa-street-view"></i> {{ $t('beneficiary') }}</b>
                <b-badge variant="light"  style="font-size: 13px">{{ toDetail.beneficiary.name }} - {{toDetail.beneficiary.document_type}} {{toDetail.beneficiary.document}}</b-badge>
              </b-list-group-item>
              <b-list-group-item
              v-if="toDetail.reason.type === 4"  
              class="d-flex justify-content-between align-items-center">
                <b class="text-primary"><i class="fas fa-times"></i> {{ $t('invalid_document') }}</b>
                <b-badge variant="light"  style="font-size: 13px">{{ toDetail.invalid_document }}</b-badge>
              </b-list-group-item>
              <b-list-group-item v-if="toDetail.amount"
              class="d-flex justify-content-between align-items-center">
                <b class="text-primary"><i class="fas fa-dollar-sign"></i> {{ $t('invoiced_amount') }}</b>
                <b-badge variant="light" style="font-size: 13px">{{ $formatDollar(toDetail.amount) }}</b-badge>
              </b-list-group-item>
              <b-list-group-item v-if="toDetail.coupon"
              class="d-flex justify-content-between align-items-center">
                <b class="text-primary"><i class="fas fa-money-bill"></i> {{ $t('coupon') }}</b>
                <b-badge variant="light" class="text-left p-2" style="font-size: 13px">
                <ul class="list-unstyled">
                  <li v-if="toDetail.coupon.code">{{ $t('code') }}: {{ toDetail.coupon.code }}</li>
                  <li>{{ $t('value') }}: {{ $formatDollar(toDetail.coupon.value) }}</li>
                </ul>
                </b-badge>
              </b-list-group-item>



            </b-list-group>


            </b-card>

          </b-card-group>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>
<style lang="scss">
</style>